module.exports = __webpack_public_path__ + "static/media/AIinTheWay.42ba4d82.webp";